import ProductLight from "../../Pages/Shop/Components/ProductComponents/ProductLight";

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css"

/**
 * DK : Swiper do tworzenia slidera z produktami
 * @param {object} products lista produktów
 * @param {string} header nagłówek
 * @param {boolean} loop nieskończone przewijanie
 * @param {boolean} refreshPage czy po kliknieciu w produkt przeładować strone
 * @returns 
 */
const CustomSwiper = ({ products, header, loop, refreshPage, autoPlay, slidesPerView = 4, handleProductClick, isMobile = false }) => {
    if (!products || products.length === 0) {
        return null
    }
    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: slidesPerView,
            slidesToSlide: slidesPerView
        },
        tablet: {
            breakpoint: { max: 1024, min: 768 },
            items: isMobile ? 1 : 3,
            slidesToSlide: isMobile ? 1 : 3
        },
        mobile: {
            breakpoint: { max: 767, min: 100 },
            items: 1,
            slidesToSlide: 1
        }
    }

    return (
        <div className="mb-2 mt-2 gd-carousel-wrapper">
            <h3 className="mb-3">{header}</h3>
            <Carousel
                className="gd-carousel-products"
                responsive={responsive}
                autoPlay={autoPlay}
                swipeable={true}
                draggable={true}
                showDots={false}
                infinite={loop}
                partialVisible={false}
                ssr={true}
            >
                {(products) && products.map((item, key) => {
                    return <ProductLight
                        product={item}
                        key={key}
                        refreshPage={refreshPage}
                        handleProductClick={handleProductClick}
                    />

                })}
            </Carousel>
        </div>
    )
}

export default CustomSwiper